/* =========================================================================
   Ripe & Ready — delivery areas.
   19 postcodes, 63 suburbs.

   THE RUN IS 19 POSTCODES around Ryde, decided 2026-10-22. It replaced the
   20 km radius of 2026-09-16. Whole postcodes, in or out. There are no
   part-served postcodes, which is why RR_OUTSIDE is empty.

   RR_AREAS   postcode -> every suburb in it. All of them are served.
   RR_OUTSIDE suburbs that share a served postcode but sit outside the run.
              Empty under a whole-postcode rule. The code that reads it is
              kept, because the first time a future run cuts through a
              postcode this is where the exceptions go.

   Suburb names come from the Australia Post locality file, street-address
   localities only: a PO box is not somewhere a crate of fruit can be left.

   Source list: operations/delivery-postcodes.md. Change the run there and
   regenerate, never by hand here.
   ========================================================================= */
window.RR_AREAS = {
 "2066": [
  "Lane Cove",
  "Lane Cove North",
  "Lane Cove West",
  "Linley Point",
  "Longueville",
  "Northwood",
  "Osborne Park",
  "Riverview"
 ],
 "2067": [
  "Chatswood",
  "Chatswood West"
 ],
 "2070": [
  "East Lindfield",
  "Lindfield",
  "Lindfield West"
 ],
 "2073": [
  "Pymble",
  "West Pymble"
 ],
 "2110": [
  "Hunters Hill",
  "Hunters Hill West",
  "Woolwich"
 ],
 "2111": [
  "Boronia Park",
  "Gladesville",
  "Henley",
  "Huntleys Cove",
  "Huntleys Point",
  "Monash Park",
  "Tennyson Point"
 ],
 "2112": [
  "Denistone East",
  "Putney",
  "Ryde"
 ],
 "2113": [
  "Blenheim Road",
  "East Ryde",
  "Macquarie Park",
  "North Ryde"
 ],
 "2114": [
  "Denistone",
  "Denistone West",
  "Meadowbank",
  "Melrose Park",
  "West Ryde"
 ],
 "2115": [
  "Ermington"
 ],
 "2116": [
  "Rydalmere"
 ],
 "2117": [
  "Dundas",
  "Dundas Valley",
  "Oatlands",
  "Telopea"
 ],
 "2121": [
  "Epping",
  "North Epping"
 ],
 "2122": [
  "Eastwood",
  "Marsfield"
 ],
 "2127": [
  "Homebush Bay",
  "Newington",
  "Sydney Olympic Park",
  "Wentworth Point"
 ],
 "2128": [
  "Silverwater"
 ],
 "2137": [
  "Breakfast Point",
  "Cabarita",
  "Concord",
  "Mortlake",
  "North Strathfield"
 ],
 "2138": [
  "Concord West",
  "Liberty Grove",
  "Rhodes"
 ],
 "2140": [
  "Homebush",
  "Homebush South",
  "Homebush West"
 ]
};

window.RR_OUTSIDE = {};
